import { combineReducers } from 'redux';
import siteDetails from './siteDetails';

export default combineReducers({ siteDetails });
